const INSTRUMENTS = [
  { key: 'NQ',   label: 'NQ',      desc: 'Nasdaq Futures' },
  { key: 'ES',   label: 'ES',      desc: 'S&P 500 Futures' },
  { key: 'MNQ',  label: 'MNQ',     desc: 'Micro NQ' },
  { key: 'GOLD', label: 'Gold',    desc: 'Gold Futures' },
  { key: 'BTC',  label: 'Bitcoin', desc: 'BTC/USD' },
];

export default function InstrumentSelector({ selected, onSelect }) {
  return (
    <div className="flex gap-2">
      {INSTRUMENTS.map(inst => {
        const isActive = selected === inst.key;
        return (
          <button
            key={inst.key}
            onClick={() => onSelect(inst.key)}
            className={`px-4 py-2 rounded-lg text-xs font-mono font-bold transition-all ${
              isActive
                ? 'bg-korinth-accent/10 text-korinth-accent border border-korinth-accent'
                : 'bg-korinth-surface text-korinth-muted border border-korinth-border hover:border-korinth-accent/50'
            }`}
            title={inst.desc}
          >
            {inst.label}
          </button>
        );
      })}
    </div>
  );
}
